export default {
  testItemTitle: 'Test Item',
  testItemId: 'รหัสรายการตรวจ',
  testItemDesc: 'ชื่อรายการตรวจ',
  buttonNewResultItem: 'เพิ่ม Result Item',
  nickname: 'ชื่อเล่น',
  sub_category_desc: 'ชื่อห้องปปฏิบัติการ',
  buttonNewTestItem: 'สร้างรายการตวจใหม่',
  buttonDeleteTesetItem: 'ลบรายการตวจ',
  newtestItem: 'สร้างรายการตรวจใหม่',
  idMissing: 'กรุณาระบุรหัสรายการตรวจ',
  descMissing: 'กรุณาระบุชื่อรายการตรวจ',
  nicknameMissing: 'กรุณาระบุชื่อย่อ',
  categoryMissing: 'กรุณาระบุห้องปโิบัติการ',
  confirmDeleteSelected: 'คุณต้องการที่จะลบรายการสั่งตรวจที่เลือก?',
  messageDeleteNotSelected: 'กรุณาเลือกรายการสั่งตรวจที่จะลบ',
  editHeader: 'แก้ไขรายการสั่งตรวจ',
  addHeader: 'เพิ่มรายการสั่งตรวจ',
  addProbe: 'เพิ่ม Probe',
  addPathogen: 'เพิ่ม Pathogen',
  code_p_type: 'Type',
  probePathogen: 'Probe/Pathogen',
  probe: 'Probe',
  pathogen: 'Pathogen',
}
